import { useEffect, useRef, useState } from "react";
import { EyeOff, MoreHorizontal, Send, Trash2 } from "lucide-react";

export default function MenuLifecycleActions({ isPublished, busyAction, onPublish, onDisable, onDelete }) {
  const busy = Boolean(busyAction);
  const [open, setOpen] = useState(false);
  const containerRef = useRef(null);

  useEffect(() => {
    if (!open) return undefined;
    const handlePointerDown = (event) => {
      if (!containerRef.current?.contains(event.target)) setOpen(false);
    };
    const handleEscape = (event) => {
      if (event.key === "Escape") setOpen(false);
    };
    document.addEventListener("mousedown", handlePointerDown);
    document.addEventListener("keydown", handleEscape);
    return () => {
      document.removeEventListener("mousedown", handlePointerDown);
      document.removeEventListener("keydown", handleEscape);
    };
  }, [open]);

  const runAction = (action) => {
    setOpen(false);
    action();
  };

  return (
    <>
      {!isPublished && (
        <button type="button" onClick={onPublish} disabled={busy} className="inline-flex h-10 items-center justify-center gap-1.5 rounded-lg border border-secondary/40 px-3.5 text-sm font-bold text-secondary hover:bg-secondary_1 disabled:cursor-wait disabled:opacity-60 focus:outline-none focus:ring-4 focus:ring-secondary/15">
          <Send size={14} aria-hidden="true" />
          {busyAction === "publish" ? "در حال انتشار..." : "انتشار منو"}
        </button>
      )}

      <div className="relative" ref={containerRef}>
        <button
          type="button"
          onClick={() => setOpen((current) => !current)}
          disabled={busy}
          aria-label="گزینه‌های بیشتر منو"
          aria-haspopup="menu"
          aria-expanded={open}
          className="inline-flex h-10 w-10 items-center justify-center rounded-lg border border-gray-200 text-gray-600 hover:bg-gray-50 hover:text-accent disabled:cursor-wait disabled:opacity-60 focus:outline-none focus:ring-4 focus:ring-gray-100"
        >
          <MoreHorizontal size={18} aria-hidden="true" />
        </button>

        {open && (
          <div role="menu" className="absolute left-0 top-full z-20 mt-1.5 w-48 rounded-xl border border-gray-200 bg-white py-1.5 shadow-lg">
            {isPublished && (
              <button type="button" role="menuitem" onClick={() => runAction(onDisable)} className="flex w-full items-center gap-2 px-3.5 py-2 text-right text-sm text-gray-700 hover:bg-gray-50 focus:bg-gray-50 focus:outline-none">
                <EyeOff size={15} className="text-gray-400" aria-hidden="true" />
                غیرفعال کردن منو
              </button>
            )}
            {isPublished && <div className="my-1.5 border-t border-gray-100" role="separator" />}
            <button type="button" role="menuitem" onClick={() => runAction(onDelete)} className="flex w-full items-center gap-2 px-3.5 py-2 text-right text-sm text-red-600 hover:bg-red-50 focus:bg-red-50 focus:outline-none">
              <Trash2 size={15} aria-hidden="true" />
              حذف منو
            </button>
          </div>
        )}
      </div>
    </>
  );
}
